import { useQuery } from '@tanstack/react-query';
import {
  WEBSITE_ANALYTICS_RECENT_LIMIT,
  WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS,
} from '../constants';
import { fetchWebsiteAnalyticsRecent } from '../services/websiteAnalytics.api';

export function useWebsiteAnalyticsRecent(enabled: boolean) {
  return useQuery({
    queryKey: ['website-analytics', 'recent', WEBSITE_ANALYTICS_RECENT_LIMIT],
    queryFn: () => fetchWebsiteAnalyticsRecent(WEBSITE_ANALYTICS_RECENT_LIMIT),
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS : false,
    retry: 1,
  });
}
